<script>
import AdminLayout from '@layouts/admin-main'
import PublicTradeList from '@components/admin/public-trade-list'

export default {
  page: {
    title: 'PublicTradeList',
    meta: [{ name: 'description', content: 'PublicTradeList' }],
  },
  components: { AdminLayout, PublicTradeList },
}
</script>

<template>
  <AdminLayout>
    <PublicTradeList />
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
